'use client';

import { c as _c } from "react/compiler-runtime";
import { ALLOWED_MEDIA, ResponsiveImage } from '@/app/components/media/app-image';
import type { SizesString } from '@/app/components/media/app-image/shared/image-size-types';
import type { SpartanProductEngineStageMediaProps } from '@/app/lcv/components/sections/spartan/products/engine/stage/media/types';
import styles from '@/app/lcv/components/sections/spartan/products/engine/styles.module.css';
import { SPARTAN_PRODUCT_ENGINE_TRACKING } from '@/app/lcv/components/sections/spartan/products/engine/tracking';
import { SpartanInViewVideo } from '@/app/lcv/components/sections/spartan/products/shared/in-view-video';
const ENGINE_STAGE_MEDIA_SIZES = '(min-width: 1280px) 676px, (min-width: 1024px) calc(100vw - 580px), (min-width: 768px) calc(100vw - 80px), calc(100vw - 32px)' as const satisfies SizesString;
export const SpartanProductEngineStageMedia = t0 => {
  const $ = _c(31);
  const {
    media,
    index,
    loading,
    fetchPriority,
    onLoad,
    onError,
    preloadOnly: t1,
    paused: t2,
    preventLoadVideo: t3
  } = t0;
  const preloadOnly = t1 === undefined ? false : t1;
  const paused = t2 === undefined ? false : t2;
  const preventLoadVideo = t3 === undefined ? false : t3;
  const imageSrc = media.image.src;
  const videoSrc = media.video?.src;
  if (!imageSrc) {
    return null;
  }
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [640, 750, 828, 1080, 1280, 1440, 1680, 1920];
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== imageSrc) {
    t5 = {
      src: imageSrc,
      sizes: ENGINE_STAGE_MEDIA_SIZES,
      widths: t4 as const,
      media: ALLOWED_MEDIA.lgDown
    };
    $[1] = imageSrc;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [1080, 1280, 1440];
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== imageSrc) {
    t7 = {
      src: imageSrc,
      sizes: ENGINE_STAGE_MEDIA_SIZES,
      widths: t6 as const,
      media: ALLOWED_MEDIA.lgUp
    };
    $[4] = imageSrc;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== fetchPriority || $[7] !== loading || $[8] !== onError || $[9] !== onLoad || $[10] !== t5 || $[11] !== t7) {
    t8 = {
      alt: "",
      mobileSrc: t5,
      desktopSrc: t7,
      loading,
      fetchPriority,
      onLoad,
      onError
    };
    $[6] = fetchPriority;
    $[7] = loading;
    $[8] = onError;
    $[9] = onLoad;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const poster = t8;
  if (preloadOnly) {
    let t9;
    if ($[13] !== fetchPriority || $[14] !== loading || $[15] !== onError || $[16] !== onLoad || $[17] !== poster.desktopSrc || $[18] !== poster.mobileSrc) {
      t9 = <ResponsiveImage mobileSrc={poster.mobileSrc} desktopSrc={poster.desktopSrc} alt="" fill={true} fade={false} loading={loading} fetchPriority={fetchPriority} objectFit="cover" onLoad={onLoad} onError={onError} />;
      $[13] = fetchPriority;
      $[14] = loading;
      $[15] = onError;
      $[16] = onLoad;
      $[17] = poster.desktopSrc;
      $[18] = poster.mobileSrc;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    return t9;
  }
  let t9;
  if ($[20] !== fetchPriority || $[21] !== imageSrc || $[22] !== index || $[23] !== loading || $[24] !== onError || $[25] !== onLoad || $[26] !== paused || $[27] !== poster || $[28] !== preventLoadVideo || $[29] !== videoSrc) {
    t9 = <div className={styles.mediaFrame}>{videoSrc ? <SpartanInViewVideo src={videoSrc} image={{
        src: imageSrc,
        alt: ""
      }} poster={poster} index={index} paused={paused} loop={true} nativeControlsOnAutoplayFailure={true} autoplayWithReducedMotion={true} startMode="visible" preload="metadata" preventLoadVideo={preventLoadVideo} sizes={ENGINE_STAGE_MEDIA_SIZES} testId={SPARTAN_PRODUCT_ENGINE_TRACKING.itemMedia(index)} mediaTestId={SPARTAN_PRODUCT_ENGINE_TRACKING.itemMediaVideo(index)} /> : <ResponsiveImage key={imageSrc} mobileSrc={{
        src: imageSrc,
        sizes: ENGINE_STAGE_MEDIA_SIZES,
        widths: [640, 750, 828, 1080, 1280, 1440, 1680, 1920] as const,
        media: ALLOWED_MEDIA.lgDown
      }} desktopSrc={{
        src: imageSrc,
        sizes: ENGINE_STAGE_MEDIA_SIZES,
        widths: [1080, 1280, 1440] as const,
        media: ALLOWED_MEDIA.lgUp
      }} alt="" fill={true} fade={false} loading={loading} fetchPriority={fetchPriority} objectFit="cover" testId={SPARTAN_PRODUCT_ENGINE_TRACKING.itemMedia(index)} onLoad={onLoad} onError={onError} />}</div>;
    $[20] = fetchPriority;
    $[21] = imageSrc;
    $[22] = index;
    $[23] = loading;
    $[24] = onError;
    $[25] = onLoad;
    $[26] = paused;
    $[27] = poster;
    $[28] = preventLoadVideo;
    $[29] = videoSrc;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};